import { type ColumnFilter } from "@tanstack/react-table";
import { type Params } from "./v4ProductReportTotals";

export const adaptFilters = (params: Params) => {
  let filters = params.filters;
  if (params.filters?.some((filter: ColumnFilter) => filter.id === "inventory_stock_state")) {
    filters = params.filters.map((filter: ColumnFilter) => {
      if (filter.id === "inventory_stock_state") {
        return {
          ...filter,
          value: {
            op: "⊃",
            // @ts-expect-error - fix types below
            value: filter.value.value[0] && filter.value.value[0] !== "all" ? filter.value.value[0] : "",
          },
        };
      }
      return filter;
    });
  }

  if (params.filters?.some((filter: ColumnFilter) => ["has_ads", "primary_variant"].includes(filter.id))) {
    filters = params.filters.map((filter: ColumnFilter) => {
      if (["has_ads", "primary_variant"].includes(filter.id)) {
        return {
          ...filter,
          value: {
            op: "=",
            // @ts-expect-error - fix types below
            value: filter.value.value[0],
          },
        };
      }
      return filter;
    });
  }

  return filters;
};
